<div class="login-page">
  <main class="login-card">
    <div class="brand-bar" aria-hidden="true"></div>

    <div class="login-card-body">
      <img
        src="/assets/img/wide-logo.png"
        alt="Healthy Contracts — Contracts Management for Healthcare"
        class="login-logo"
      />

      @if (isSSOEnabled) {
        <!-- SSO Mode: Show loading while redirecting -->
        <div class="sso-loading">
          <mat-spinner diameter="36"></mat-spinner>
          <p>Redirecting to single sign-on…</p>
        </div>
      } @else {
        <!-- Non-SSO Mode: Show standard login form -->
        <div class="login-heading">
          <h1>Sign in</h1>
          @if (orgFormalName) {
            <p class="org-name">{{ orgFormalName }}</p>
          }
        </div>

        <form class="login-form" (ngSubmit)="onLogin()">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Username</mat-label>
            <input
              matInput
              type="text"
              [(ngModel)]="username"
              name="username"
              autocomplete="username"
              autocapitalize="none"
              spellcheck="false"
              required
            />
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Password</mat-label>
            <input
              matInput
              [type]="showPassword ? 'text' : 'password'"
              [(ngModel)]="password"
              name="password"
              autocomplete="current-password"
              required
            />
            <button
              mat-icon-button
              matSuffix
              type="button"
              (click)="showPassword = !showPassword"
              [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'"
            >
              <mat-icon>{{ showPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
          </mat-form-field>

          @if (errorMessage()) {
            <div class="login-error" role="alert">
              <mat-icon>error_outline</mat-icon>
              <span>{{ errorMessage() }}</span>
            </div>
          }

          <button
            mat-flat-button
            type="submit"
            class="sign-in-button"
            [disabled]="!username || !password || signingIn()"
          >
            {{ signingIn() ? 'Signing in…' : 'Sign in' }}
          </button>

          <button mat-button type="button" class="forgot-link" (click)="forgotPassword()">
            Forgot password?
          </button>
        </form>
      }
    </div>
  </main>

  <footer class="login-footer">
    &copy; {{ currentYear }} Business Data Apps · Healthy Contracts
  </footer>
</div>
